import { NotificationService } from './../../../../Services/notification.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { initFlowbite } from 'flowbite';
import { StockDetailService } from '../../../../Services/Stock-Details/stock-detail.service';
import { UserCustomerService } from '../../../../Services/User/Customer/user-customer.service';
import { StockOutService } from '../../../../Services/Stock_Transactions/Stock_out/stock-out.service';
import { FirmService } from '../../../../Services/firm.service';
import { ReadyProductService } from '../../../../Services/Ready-Product/ready-product.service';
import { HttpParams } from '@angular/common/http';
import { filter } from 'rxjs';
import { RateListGeneratorService } from '../../../../Services/Rate_List_Generator/rate-list-generator.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { AdminSettingsService } from '../../../../Services/Admin_Settings/admin-settings.service';
import { AuthService } from '../../../../Services/auth.service';
import { CategoryService } from '../../../../Services/Category/category.service';
import { OnlyNumberDirective } from '../../../../shared/only-number.directive';
import { AccountService } from '../../../../Services/Accounts/account.service';
import { WeightScaleService } from '../../../../Services/WeightScale/weight-scale.service';
import {
  mapUserCustomerTypeToRateListType,
  matchesRateListWeight,
  pickBestRateListMatch,
} from '../../../../shared/rate-list-customer-type';

export interface InvoiceItem {
  itId: string;
  metal: string;
  itemDet: string;
  qty: number;
  gsWt: number;
  ntWt: number;
  purity: string;
  wstg: number;
  fnPurity: number;
  custWstg: string;
  ffineWt: number;
  valAdd: string;
  mkgChrgs: number;
  othChrgs: number;
  totMkgChrgs: number;
  amt: number;
  mkgDisc: string;
  disc: string;
  val: number;
  cryVal: string;
  totHmc: string;
  totTax: string;
  finalVal: number;
  mrp: number;
  status: string;
}
export interface BarcodeItem {
  barcode: string;
  productCode: string;
  quantity: string;
  weight: string;
  finalValue: string;
  rangeCode?: string;
  //  packaging
  packagingStackId?: number | null;
}

@Component({
  selector: 'app-sell-details-lot',
  standalone: true,
  imports: [
    NgFor,
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    OnlyNumberDirective
  ],
  templateUrl: './sell-details-lot.component.html',
  styleUrls: ['./sell-details-lot.component.css'],
  providers: [DatePipe]
})
export class SellDetailsLotComponent implements OnInit, OnDestroy {

  weighingScaleEnabled = false;
  weighingScaleSetting: any = null;
  autoWeightInterval: any = null;

  isProductDetailsVisible = false;

  stoneForms: number[] = [];
  private nextStoneId = 0;
  activeTab: 'add' | 'return' | null = null;
  addProductForm!: FormGroup;
  sellProductForm!: FormGroup;
  customerId: any;
  barcodeList: BarcodeItem[] = [];

  filteredBarcodes: BarcodeItem[] = [];
  selectedIndex = -1;
  customerDetails: any;
  selectedProductCode: string = '';
  selectedQuantity: any;
  selectedFinalValue: any;
  rangeCode!: any;
  rateParams: any;
  isDropdownVisible = false;
  /** After a not-found scan, keep the value visible; clear only when next scan/typing starts. */
  private clearBarcodeOnNextInput = false;
  detailsForm: FormGroup;
  selectedFirm: any;
  selectedWt: any;
  rateListData: any;
  isLoading: boolean = false;
  invoiceItemDetails: any;
  manualSell: boolean = false;
  autoSell: boolean = false;
  popupForm!: FormGroup;
  selectedGroup: any;
  isPopupOpen = false;
  isSilverRatePopupOpen = false;
  silverRateForm!: FormGroup;
  lotWiseForm!: FormGroup;
  showLotWise: boolean = false;
  showPieceWise: boolean = false;
  //  Packaging checkbox state
  selectedItemHasPackaging: boolean = false;
  private packagingAutoTimer: any = null;
  packagingMode: 'always' | 'never' | 'ask' = 'always';
  hasAnyPackagingStock: boolean = false;
  prodCategory: any;
  serverError: string = '';
  salesAccounts: any[] = [];

  constructor(
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute,
    private stockDetailService: StockDetailService,
    private router: Router,
    private datePipe: DatePipe,
    private userCustomerService: UserCustomerService,
    private stockOutService: StockOutService,
    private firmService: FirmService,
    private readyProductService: ReadyProductService,
    private rateListGeneratorService: RateListGeneratorService,
    private firmSelectionService: FirmSelectionService,
    private adminSettingsService: AdminSettingsService,
    private authService: AuthService,
    private categoryService: CategoryService,
    private accountService: AccountService,
    private weightScaleService: WeightScaleService
  ) {
    this.detailsForm = this.fb.group({
      addDetail: [false],
      addEcom: [false],
      fixMrp: [false]
    });
  }

  ngOnInit(): void {
    this.customerId = this.activatedRoute.snapshot.paramMap.get('id');
    this.initProductForm();
    this.initPopupForm();
    this.initSilverRateForm();
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      this.selectedFirm = firm?.id;
      this.initSellProductForm();
      this.setDate();
    });
    this.getCustomerDetails();
    this.getInvoiceNumber();
    this.getCategories();

    initFlowbite();
    this.addStoneForm();
    this.getAdminSettings();
    this.getSalesAccounts();
    this.loadWeighingScaleSettings();
  }

  initProductForm() {
    this.addProductForm = this.fb.group({
      start_range_1: ['']
    });
  }

  initPopupForm() {
    this.popupForm = this.fb.group({
      value: ['']
    });
  }

  initSilverRateForm() {
    this.silverRateForm = this.fb.group({
      silverRate: ['']
    });
  }

  getBarcodeFromPaymentPanel() {
    this.stockOutService.getBarcode().pipe(
      filter((barcodeData): barcodeData is string => barcodeData !== null)
    ).subscribe(barcode => {

      this.addProductForm.patchValue({
        'start_range_1': barcode
      });
      this.isProductDetailsVisible = true;
      this.sellProductForm.get('stout_barcode')?.patchValue(barcode);
      const selectedItem = this.barcodeList.find(item => item.barcode === barcode);

      if (selectedItem) {
        this.selectedProductCode = selectedItem.productCode;
        this.selectedQuantity = selectedItem.quantity;
        this.selectedWt = selectedItem.weight;
        this.selectedFinalValue = selectedItem.finalValue;
        this.rangeCode = selectedItem.rangeCode;

        this.onGoClick('add', this.selectedProductCode, this.selectedQuantity, this.selectedWt, this.selectedFinalValue);
      } else {
        // this.notificationService.showError('Barcode not found in stock list', 'Error');
      }
    });
  }

  setDate() {
    const today = new Date();
    const formattedToday = this.datePipe.transform(today, 'yyyy-MM-dd');
    this.sellProductForm.patchValue({
      stout_bill_date: formattedToday,
      stout_sale_month: formattedToday
    });

    this.getBarcodeData();
    this.loadFirmList();

    this.addProductForm.get('start_range_1')?.valueChanges.subscribe(value => {
      this.filteredBarcodes = this.barcodeList.filter(item =>
        item.barcode.toLowerCase().includes(value?.toLowerCase() || '')
      );
      this.selectedIndex = -1;
    });

    this.addProductForm.get('start_range_1')?.valueChanges.subscribe(value => {
      this.sellProductForm.patchValue({ barcode: value });
    });
  }

  loadFirmList() {
    this.firmService.getFirms().subscribe((res: any) => {
      this.firmTypes = res.data;
    });
  }

  initSellProductForm() {
    this.sellProductForm = this.fb.group({
      stout_bill_date: [''],
      stout_customer_name: [''],
      stout_billing_name: [''],
      sell_weight: [''],
      stout_invoice_number: [''],
      stout_firm_id: this.selectedFirm,
      stout_account: [''],
      stout_sale_executive: [''],
      stout_sale_month: [''],
      stout_metal_type: ['Silver'],
      stout_item_category: [''],
      stout_item_name: [''],
      stout_item_code: [''],
      stout_quantity: [''],
      stout_net_weight: [''],
      stout_purity: [''],
      stout_fine_weight: [''],
      stout_weight_range: [''],
      stout_category_unit: [''],
      stout_per_gram_labour: [''],
      stout_mrp_percent: [''],
      stout_final_fine_weight: [''],
      stout_unit_price: [''],
      stout_metal_rate: [''],
      stout_final_amount: [''],
      barcode: [''],
      stout_status: 'pending_invoice',
      stout_barcode: [''],
      stout_customer_id: [this.customerId],
      stout_total_wt: [''],
      stout_available_wt: [''],
      //  packaging toggle
      use_packaging: [true],

    });

    this.bindCalculationListeners();
    //  AUTO MODE: submit immediately when packaging toggled
    this.sellProductForm.get('use_packaging')?.valueChanges.subscribe(value => {

      if (!this.autoSell) return;
      if (!this.selectedProductCode) return;
      if (!this.selectedItemHasPackaging) return;

      console.log(' Packaging changed → Auto selling:', value);

      //  Cancel pending auto sell
      if (this.packagingAutoTimer) {
        clearTimeout(this.packagingAutoTimer);
        this.packagingAutoTimer = null;
      }

      setTimeout(() => {
        this.submitForm();
      }, 150);
    });

    this.setDefaultSalesAccount();
  }

  setDefaultSalesAccount() {
    if (this.sellProductForm && this.salesAccounts.length > 0) {
      const salesAcc = this.salesAccounts.find(acc =>
        acc.acc_name.toLowerCase().trim() === 'sales'
      );
      if (salesAcc) {
        this.sellProductForm.patchValue({
          stout_account: salesAcc.acc_name
        });
      }
    }
  }

  triggerRecalculation() {
    this.calculateFineWeight();
    this.syncSellWeight();
    this.calculateFinalAmount();
  }


  bindCalculationListeners() {
    const form = this.sellProductForm;

    [
      'stout_net_weight',
      'stout_purity',
      'stout_per_gram_labour',
      'stout_unit_price',
      'stout_mrp_percent',
      'stout_category_unit'
    ].forEach(control => {
      form.get(control)?.valueChanges.subscribe(() => {
        this.calculateFineWeight();
        this.syncSellWeight();      // 🔥 NEW
        this.calculateFinalAmount();
      });
    });
  }




  calculateFineWeight() {
    const form = this.sellProductForm;

    const unit = form.get('stout_category_unit')?.value;
    const netWeight = +form.get('stout_net_weight')?.value || 0;
    const purity = +form.get('stout_purity')?.value || 0;

    let fineWeight = 0;

    /* ===============================
       BY GRAM → ALWAYS NET WT
    =============================== */
    if (unit === 'By Gram' && netWeight) {
      fineWeight = netWeight;
    }

    /* ===============================
       BY SILVER RATE
    =============================== */
    else if (unit === 'By Silver Rate' && purity && netWeight) {
      fineWeight = (netWeight * purity) / 100;
    }

    if (!fineWeight) return;

    form.patchValue(
      { stout_fine_weight: fineWeight.toFixed(2) },
      { emitEvent: false }
    );
  }

  syncSellWeight() {
    const form = this.sellProductForm;

    const unit = form.get('stout_category_unit')?.value;
    const netWeight = +form.get('stout_net_weight')?.value || 0;
    const fineWeight = +form.get('stout_fine_weight')?.value || 0;

    let sellWeight = 0;

    if (unit === 'By MRP') {
      sellWeight = netWeight;
    }
    else if (unit === 'By Gram' || unit === 'By Silver Rate') {
      sellWeight = fineWeight;
    }

    if (!sellWeight) return;

    form.patchValue(
      { sell_weight: sellWeight },
      { emitEvent: false }
    );
  }

  calculateFinalAmount() {
    const form = this.sellProductForm;

    const unit = form.get('stout_category_unit')?.value;

    const sellWeight = +form.get('sell_weight')?.value || 0;
    const labour = +form.get('stout_per_gram_labour')?.value || 0;

    const unitPrice = +form.get('stout_unit_price')?.value || 0;
    const mrpPercent = +form.get('stout_mrp_percent')?.value || 0;

    let finalAmount = 0;

    /* ===============================
       BY GRAM
    =============================== */
    if (unit === 'By Gram' && sellWeight && labour) {
      finalAmount = sellWeight * labour;
    }

    /* ===============================
       BY MRP (DISCOUNT)
    =============================== */
    else if (unit === 'By MRP' && unitPrice) {
      const discount = (unitPrice * mrpPercent) / 100;
      finalAmount = unitPrice - discount;
    }

    /* ===============================
       PATCH RESULT
    =============================== */
    if (finalAmount <= 0) return;

    form.patchValue(
      { stout_final_amount: finalAmount.toFixed(2) },
      { emitEvent: false }
    );
  }

  submitForm() {
    this.stockOutService.createStockOutEntry(this.sellProductForm.getRawValue()).subscribe({
      next: (response: any) => {
        this.serverError = '';
        this.notificationService.showSuccess('Stock Out Entry Created Successfully', 'Success');
        this.getBarcodeData();
        this.getInvoiceItemsDetails();
        this.clearSellProductForm();
        this.addProductForm.patchValue({
          start_range_1: ''
        })
      },
      error: (error: any) => {
        console.error('Error creating Stock Out Entry:', error);
        this.serverError = error.error?.message || error.message || 'Failed to create Stock Out Entry';
        this.notificationService.showError(this.serverError, 'Error');
      }
    });
  }

  submitAndBill() {
    this.isSilverRatePopupOpen = true;
  }

  submitSilverRate() {
    const silverRate = Number(this.silverRateForm.get('silverRate')?.value);

    if (!silverRate || isNaN(silverRate) || silverRate <= 0) {
      this.notificationService.showError('Please enter a valid Silver Rate', 'Error');
      return;
    }

    // Filter only items having stout_fine_weight (GRAM or RATE-based)
    const itemsToUpdate = this.invoiceItemDetails.filter(
      (item: any) => item.stout_fine_weight && item.stout_fine_weight > 0
    );

    if (!itemsToUpdate.length) {
      // this.notificationService.showError('No valid items found to update', 'Error');
      this.closeSilverRatePopup();
      // return;
    }

    // Call backend to bulk update total amount
    this.stockOutService.updateSilverRate(itemsToUpdate, silverRate).subscribe({
      next: () => {
        this.notificationService.showSuccess('All items updated successfully', 'Success');
        this.closeSilverRatePopup();
        this.getInvoiceItemsDetails();
        // Redirect to billing page
        this.router.navigate(['/payment-details', this.customerId], { queryParams: { refresh: true } });
      },
      error: (err: any) => {
        console.error(err);
        // this.notificationService.showError('Failed to update Silver Rate', 'Error');
        this.closeSilverRatePopup();
        this.router.navigate(['/payment-details', this.customerId], { queryParams: { refresh: true } });
      }
    });
  }

  skipSilverValue() {
    this.router.navigate(['/payment-details', this.customerId], { queryParams: { refresh: true } });
  }

  closeSilverRatePopup() {
    this.isSilverRatePopupOpen = false;
  }


  clearSellProductForm() {
    this.sellProductForm.patchValue({
      stout_item_category: '',
      stout_weight_range: '',
      stout_quantity: '',
      stout_net_weight: '',
      stout_per_gram_labour: '',
      stout_mrp_percent: '',
      stout_unit_price: '',
      stout_purity: '',
      stout_fine_weight: '',
      stout_final_amount: '',
    });

    // Reset Sales Account to default
    this.setDefaultSalesAccount();
  }

  showProductDetails(): void {
    this.isProductDetailsVisible = true;
  }
  addStoneForm(): void {
    this.stoneForms.push(this.nextStoneId++);
  }

  removeStoneForm(idToRemove: number): void {
    this.stoneForms = this.stoneForms.filter(id => id !== idToRemove);
  }

  onGoClick(type: 'add' | 'return', productCode?: string, quantity?: string, weight?: string, finalValue?: string, autoSubmit: boolean = false) {
    const barcodeValue = this.addProductForm.get('start_range_1')?.value;

    if (!barcodeValue) {
      this.notificationService.showError('Please select a barcode first!', 'Error');
      return;
    }

    this.sellProductForm.patchValue({ barcode: barcodeValue });

    if (this.customerDetails?.name) {
      this.sellProductForm.patchValue({
        stout_customer_name: this.customerDetails.name,
        stout_billing_name: this.customerDetails.name
      });
    }

    this.getProductCodeData(productCode, quantity, weight, finalValue, autoSubmit);
    this.activeTab = type;
    this.isProductDetailsVisible = true;
  }

  categoryId: any;

  getProductCodeData(itemCode: any, quantity: any, weight: any, finalValue: any, autoSubmit: boolean = false) {
    const params = new HttpParams().append('product_code', itemCode);
    this.readyProductService.getReadyProducts(params).subscribe((response: any) => {
      const product = response.data[0];

      // Category may arrive as object {id} or raw id string/number
      const resolvedCategoryId =
        product.rproduct_categories?.id ?? product.rproduct_categories ?? null;
      this.categoryId = resolvedCategoryId;

      console.log('ready products', product, 'resolvedCategoryId', resolvedCategoryId);

      this.sellProductForm.patchValue({
        stout_item_category: resolvedCategoryId,
        stout_item_name: product.rproduct_name,
        stout_item_code: product.rproduct_code,
        stout_quantity: quantity,
        stout_net_weight: weight,
        stout_tag_weight: weight,
        stout_net_wt_unit: product.rproduct_unit,
        stout_total_wt: weight,
        stout_unit_price: finalValue,
      });

      this.getRateListGeneratorData(resolvedCategoryId, weight, finalValue, autoSubmit, this.rangeCode);
    });
  }


  unitForWithoutRateList: any;

  getRateListGeneratorData(categoryId: number, net_weight: any, mrp: any, autoSubmit: boolean = false, barcodeRangeCode?: string) {
    this.isLoading = true;

    /* ---------------- RESET FORM ---------------- */
    this.sellProductForm.patchValue({
      stout_net_weight: '',
      stout_fine_weight: '',
      stout_unit_price: '',
      stout_per_gram_labour: '',
      stout_weight_range: '',
      stout_category_unit: '',
      stout_mrp_percent: '',
      stout_purity: '',
      stout_final_amount: '',
      sell_weight: ''
    }, { emitEvent: false });

    /* ---------------- FETCH CATEGORY (FALLBACK) ---------------- */
    const catParams = new HttpParams().set('id', categoryId);


    this.categoryService.getCategories(catParams).subscribe((catRes: any) => {
      this.unitForWithoutRateList = catRes?.data?.[0] || null;

      // Identify if this specific product is a LOT or PIECE
      const isLotItem = this.unitForWithoutRateList?.SubType === 'lot';

      console.log("check for lot item", isLotItem);

      if (isLotItem) {
        this.showLotWise = true;
        this.showPieceWise = false;
      } else {
        this.showPieceWise = true;
        this.showLotWise = false;
      }

      /* ---------------- CUSTOMER TYPE → RATE LIST TYPE ---------------- */
      const mappedCustomerType = mapUserCustomerTypeToRateListType(
        this.customerDetails?.user_customer_type
      );

      /* ---------------- FETCH RATE LIST (category + type only) ---------------- */
      this.rateParams = new HttpParams().set('category', String(categoryId));
      if (mappedCustomerType) {
        this.rateParams = this.rateParams.set('customer_type', mappedCustomerType);
      }

      if (mappedCustomerType) {
        this.rateListGeneratorService.getRateList(this.rateParams).subscribe((rateRes: any) => {
          this.rateListData = rateRes?.data || [];
          this.processRateSelection(net_weight, mrp, autoSubmit, barcodeRangeCode, isLotItem);
        });
      } else {
        // Family / Friend: no Rate List
        this.rateListData = [];
        this.processRateSelection(net_weight, mrp, autoSubmit, barcodeRangeCode, isLotItem);
      }
    });
  }

  private processRateSelection(
    net_weight: any,
    mrp: any,
    autoSubmit: boolean,
    barcodeRangeCode: any,
    isLotItem: boolean
  ) {
    const wt = Number(net_weight) || 0;

    const unit =
      this.rateListData.length > 0
        ? this.rateListData[0].rlg_unit
        : this.unitForWithoutRateList?.unit;

    if (!unit) {
      this.isLoading = false;
      return;
    }

    this.sellProductForm.patchValue({
      stout_category_unit: unit
    }, { emitEvent: false });

    let rateSource: any = null;

    if (this.rateListData.length > 0) {
      if (unit === 'By Gram') {
        const matches = (this.rateListData || []).filter((item: any) =>
          matchesRateListWeight(item, wt)
        );
        rateSource = pickBestRateListMatch(matches);
      } else {
        rateSource = this.rateListData[0];
      }
    }

    if (!rateSource) {
      rateSource = this.unitForWithoutRateList;
    }

    // Piece always gets barcode weight. Lot keeps manual/scale entry unless weight already known.
    const patchWeight = !isLotItem || wt > 0
      ? { stout_net_weight: wt, stout_available_wt: wt }
      : {};

    if (unit === 'By Silver Rate') {
      const purity = Number(rateSource?.rlg_purity ?? rateSource?.purity ?? 0);
      this.sellProductForm.patchValue({ ...patchWeight, stout_purity: purity }, { emitEvent: false });
      this.triggerRecalculation();
    } else if (unit === 'By MRP') {
      const discount = Number(rateSource?.rlg_discount || 0);
      const baseMrp = Number(mrp) || 0;
      this.sellProductForm.patchValue({
        ...patchWeight,
        stout_unit_price: baseMrp,
        stout_mrp_percent: discount
      }, { emitEvent: false });
      this.triggerRecalculation();
    } else if (unit === 'By Gram') {
      const labour = Number(rateSource?.rlg_per_gm_labour || 0);
      const rangeCode = rateSource?.rlg_code || '';
      this.sellProductForm.patchValue({
        ...patchWeight,
        stout_per_gram_labour: labour,
        stout_weight_range: rangeCode
      }, { emitEvent: false });
      this.triggerRecalculation();
    }

    if (autoSubmit && !isLotItem) {
      this.submitForm();
    }

    this.isLoading = false;
  }

  onLotNetWtChange(event: any) {
    const value = Number(event.target.value) || 0;
    if (!this.categoryId) {
      return;
    }

    const mappedCustomerType = mapUserCustomerTypeToRateListType(
      this.customerDetails?.user_customer_type
    );

    if (!mappedCustomerType) {
      return;
    }

    let params = new HttpParams()
      .set('category', String(this.categoryId))
      .set('customer_type', mappedCustomerType)
      .set('fine_weight', String(value));

    this.rateListGeneratorService.getRateList(params).subscribe((res: any) => {
      const rateList = res?.data || [];
      const matchedRate = pickBestRateListMatch(
        rateList.filter((item: any) => matchesRateListWeight(item, value))
      );

      if (matchedRate) {
        this.sellProductForm.patchValue({
          stout_weight_range: matchedRate.rlg_code,
          stout_per_gram_labour: matchedRate.rlg_per_gm_labour
        }, { emitEvent: false });
        this.triggerRecalculation();
      }
    });
  }

  getCustomerDetails() {
    this.userCustomerService.getUserCustomerById(this.customerId).subscribe({
      next: (response: any) => {
        this.customerDetails = response.data;
        this.getBarcodeData();
        this.getInvoiceItemsDetails();
      },
      error: (error: any) => {
        console.error('Error fetching customer details:', error);
        this.notificationService.showError('Failed to fetch customer details', 'Error');
      }
    });
  }

  getInvoiceNumber() {
    this.stockOutService.getInvoiceNumber(this.customerId).subscribe((response: any) => {
      this.sellProductForm.patchValue({
        stout_invoice_number: response.invoice_number
      });
    });
  }

  getBarcodeData() {
    let params: HttpParams;
    if (this.customerDetails?.user_customer_type === "Wholesale" ||
      this.customerDetails?.user_customer_type === "Retailer") {
      // params = new HttpParams().set('std_product_type', 'lot-wise');
    } else {
      // params = new HttpParams().set('std_product_type', 'piece-wise');
    }

    params = new HttpParams();

    if (this.authService.getUserRole() === 'Staff') {
      if (this.authService.getUserStaffType() === 'Field') {
        params = params.append('issued_stock_id', this.authService.getUserId());
      }
    }


    this.stockDetailService.getStockDetails(params).subscribe({
      next: (response: any) => {
        this.barcodeList = response.data
          .filter((item: any) => {
            if (item.stock_status === 'sold') {
              return false;
            }
            const userRole = this.authService.getUserRole();
            const staffType = this.authService.getUserStaffType();
            const userId = this.authService.getUserId();
            if (userRole === 'Staff' && staffType === 'Field') {
              return item.issued_stock_id == userId;
            } else if (userRole === 'Staff' && staffType === 'General') {
              return !item.issued_stock_id || item.issued_stock_id == userId;
            } else {
              return !item.issued_stock_id;
            }
          })
          .map((item: any) => ({
            barcode: item.std_barcode,
            productCode: item.std_item_code,
            quantity: item.std_quantity,

            //CHNAGED FOR LOT WISE SALE — always use total wt for piece-wise (net wt patched from total wt)
            weight: item.std_total_wt,
            finalValue: item.std_unit_price,
            rangeCode: item.std_rate_list_code,
            //  packaging present or not
            //  added for checkbox 
            packagingStackId: item.packaging_stack_id,
          }));
        this.hasAnyPackagingStock = this.barcodeList.some(
          item => !!item.packagingStackId
        );

        this.getBarcodeFromPaymentPanel();
      },
      error: (error: any) => {
        console.error('Error fetching barcode data:', error);
      }
    });
  }
  //method for checkbox packaging
  private updatePackagingUI(item: any) {

    const hasPackaging = !!item.packagingStackId;
    const ctrl = this.sellProductForm.get('use_packaging');

    if (!ctrl) return;

    this.selectedItemHasPackaging = hasPackaging;

    if (!hasPackaging) {
      ctrl.setValue(false, { emitEvent: false });
      return;
    }

    if (this.packagingMode === 'always') {
      ctrl.setValue(true, { emitEvent: false });
    }
    else if (this.packagingMode === 'never') {
      ctrl.setValue(false, { emitEvent: false });
    }
    else {
      ctrl.setValue(true, { emitEvent: false });
    }
  }

  onSelectBarcode(barcode: string) {
    this.sellProductForm.get('stout_barcode')?.patchValue(barcode);
    const selectedItem = this.filteredBarcodes.find(item => item.barcode === barcode);

    if (selectedItem) {
      this.selectedProductCode = selectedItem.productCode;
      this.selectedQuantity = selectedItem.quantity;
      this.selectedWt = selectedItem.weight;
      this.selectedFinalValue = selectedItem.finalValue;
      this.rangeCode = selectedItem.rangeCode;

      //  HANDLE PACKAGING added for checkbox fun
      this.updatePackagingUI(selectedItem);
      this.addProductForm.get('start_range_1')?.setValue(barcode);
    }

    this.filteredBarcodes = [];
    this.isDropdownVisible = false;
  }

  onSelectBarcodeForAutoSell(barcode: string) {

    this.sellProductForm.get('stout_barcode')?.patchValue(barcode);
    const selectedItem = this.barcodeList.find(item => item.barcode === barcode);

    if (selectedItem) {

      this.selectedProductCode = selectedItem.productCode;
      this.selectedQuantity = selectedItem.quantity;
      this.selectedWt = selectedItem.weight;
      this.selectedFinalValue = selectedItem.finalValue;

      // update packaging checkbox state
      this.updatePackagingUI(selectedItem);

      this.addProductForm.get('start_range_1')?.setValue(barcode);

      const hasPackaging = !!selectedItem.packagingStackId;



      if (hasPackaging) {

        //  GLOBAL MODE: ALWAYS APPLY
        if (this.packagingMode === 'always') {

          this.sellProductForm.get('use_packaging')?.setValue(true, { emitEvent: false });

          this.onGoClick(
            this.activeTab ?? 'add',
            this.selectedProductCode,
            this.selectedQuantity,
            this.selectedWt,
            this.selectedFinalValue,
            true
          );

          return;
        }

        //  GLOBAL MODE: NEVER APPLY
        if (this.packagingMode === 'never') {

          this.sellProductForm.get('use_packaging')?.setValue(false, { emitEvent: false });

          this.onGoClick(
            this.activeTab ?? 'add',
            this.selectedProductCode,
            this.selectedQuantity,
            this.selectedWt,
            this.selectedFinalValue,
            true
          );

          return;
        }

        //  ASK MODE (current behavior)
        this.onGoClick(
          this.activeTab ?? 'add',
          this.selectedProductCode,
          this.selectedQuantity,
          this.selectedWt,
          this.selectedFinalValue,
          false
        );

        this.notificationService.showInfo(
          'Packaging available. Please confirm before selling.',
          'Confirm Packaging'
        );

        this.packagingAutoTimer = setTimeout(() => {
          this.submitForm();
        }, 5000);

      } else {

        this.onGoClick(
          this.activeTab ?? 'add',
          this.selectedProductCode,
          this.selectedQuantity,
          this.selectedWt,
          this.selectedFinalValue,
          true
        );
      }

    }

    this.filteredBarcodes = [];
    this.isDropdownVisible = false;
  }


  onFocusInput() {
    this.filteredBarcodes = [...this.barcodeList];
    this.selectedIndex = -1;
    this.isDropdownVisible = true;
  }

  onBlurInput(): void {
    setTimeout(() => {
      this.isDropdownVisible = false;
    }, 200);
  }

  onKeyDown(event: KeyboardEvent) {
    const maxIndex = this.filteredBarcodes.length - 1;

    // Next scan/typing after not-found: clear old barcode first so values do not append
    if (
      this.clearBarcodeOnNextInput &&
      event.key.length === 1 &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.altKey
    ) {
      this.addProductForm.get('start_range_1')?.setValue('');
      this.clearBarcodeOnNextInput = false;
    }

    if (event.key === 'ArrowDown') {
      this.selectedIndex = (this.selectedIndex + 1) > maxIndex ? 0 : this.selectedIndex + 1;
      event.preventDefault();
    }
    else if (event.key === 'ArrowUp') {
      this.selectedIndex = (this.selectedIndex - 1) < 0 ? maxIndex : this.selectedIndex - 1;
      event.preventDefault();
    }
    else if (event.key === 'Enter') {
      event.preventDefault();

      // 1. Priority: Dropdown selection
      if (this.selectedIndex >= 0 && this.filteredBarcodes[this.selectedIndex]) {
        this.clearBarcodeOnNextInput = false;
        if (this.autoSell) {
          this.onSelectBarcodeForAutoSell(this.filteredBarcodes[this.selectedIndex].barcode);
        } else {
          this.onSelectBarcode(this.filteredBarcodes[this.selectedIndex].barcode);
        }
      }
      // 2. Priority: Direct Scanner Input
      else {
        const scannedValue = this.addProductForm.get('start_range_1')?.value;
        if (scannedValue) {
          const foundItem = this.barcodeList.find(
            item => item.barcode.toLowerCase().trim() === scannedValue.toLowerCase().trim()
          );

          if (foundItem) {
            this.clearBarcodeOnNextInput = false;
            if (this.autoSell) {
              this.onSelectBarcodeForAutoSell(foundItem.barcode);
            } else {
              this.onSelectBarcode(foundItem.barcode);
            }
            this.isDropdownVisible = false;
            this.selectedIndex = -1;
          } else {
            this.clearBarcodeOnNextInput = true;
            this.notificationService.showError('Barcode not found in list', 'Error');
          }
        }
      }
    }
  }

  groupedInvoiceItems: any[] = [];

  getInvoiceItemsDetails() {
    const params = new HttpParams()
      .set('customer_id', this.customerId)
      .set('invoice_status', 'pending_invoice');

    this.stockOutService.getStockOutEntries(params).subscribe((response: any) => {
      this.invoiceItemDetails = response.data || [];
      this.groupedInvoiceItems = this.groupInvoiceItemsByCategory();
      console.log("cart data is", this.groupedInvoiceItems);

    });
  }

  getCategories() {
    let params = new HttpParams();
    this.categoryService.getCategories(params).subscribe((res: any) => {
      console.log("Raw Categories from API:", res.data);

      if (!Array.isArray(res?.data)) {
        console.error("Data is not an array or is missing");
        return;
      }

      this.prodCategory = res.data
        .filter((item: any) => {

          // normalize type safely
          const type = (item.Type || item.type || '').toString().toLowerCase().trim();

          const isMasterOrAssembly =
            type === 'master' ||
            type === 'assembly' ||
            type === 'product';

          const hasUnit = !!item.unit && item.unit.toString().trim() !== '';

          return isMasterOrAssembly && hasUnit;
        })
        .map((item: any) => ({
          id: item.id,
          name: item.name,
          unit: item.unit,
          displayName: `${item.name} (${item.unit})`
        }));

      console.log("Filtered Categories for UI:", this.prodCategory);
    });
  }

  groupInvoiceItemsByCategory() {
    if (!this.invoiceItemDetails || !this.invoiceItemDetails.length) return [];

    const grouped: {
      [key: string]: {
        categoryName: string;
        weightRange?: string;
        qty: number;
        fineWt: number;
        totalWt: number;
        amt: number;
        finalVal: number;
        items: any[];
      };
    } = {};

    this.invoiceItemDetails.forEach((item: any) => {
      const category = item.stout_item_category || 'Unknown';
      const categoryName = item?.category ? `${item.category.name} (#${item.category.unit})` : 'Unknown';
      console.log("category name is", categoryName);

      const weightRange =
        category === 'GRAM' ? (item.stout_weight_range || 'Unknown Range') : '';

      const groupKey = category === 'GRAM' ? `${category}_${weightRange}` : category;

      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          categoryName,
          weightRange: category === 'GRAM' ? weightRange : undefined,
          qty: 0,
          totalWt: 0,
          fineWt: 0,
          amt: 0,
          finalVal: 0,
          items: [],
        };
      }

      grouped[groupKey].qty += Number(item.stout_quantity) || 0;
      grouped[groupKey].totalWt += Number(item.stout_total_wt) || 0;
      grouped[groupKey].amt += Number(item.stout_unit_price) || 0;
      grouped[groupKey].fineWt += Number(item.stout_fine_weight) || 0;
      grouped[groupKey].finalVal += Number(item.stout_final_amount) || 0;
      grouped[groupKey].items.push(item);
    });
    return Object.values(grouped);
  }

  getAdminSettings() {
    this.adminSettingsService.getAdminSettings().subscribe({
      next: (response: any) => {
        const settings = response.data?.[0];
        if (!settings) {
          this.manualSell = true;
          this.autoSell = false;
          return;
        }

        if (settings.sell_type === "manual") {
          this.manualSell = true;
          this.autoSell = false;
        } else if (settings.sell_type === "auto") {
          this.manualSell = false;
          this.autoSell = true;
        } else {
          this.manualSell = true;
          this.autoSell = false;
        }
      },
      error: (err) => {
        console.error("Error fetching admin settings:", err);
        this.manualSell = true;
        this.autoSell = false;
      }
    });
  }

  keyForCategory: string = '';
  openEditPopup(group: any) {
    this.selectedGroup = group;
    let initialValue = 0;

    if (group.items[0].stout_category_unit === 'By MRP') {
      initialValue = group.items[0].stout_mrp_percent || 0;
      this.keyForCategory = 'MRP%';
    } else if (group.items[0].stout_category_unit === 'By Gram') {
      initialValue = group.items[0].stout_per_gram_labour || 0;
      this.keyForCategory = 'Labour';
    } else if (group.items[0].stout_category_unit === 'By Silver Rate') {
      initialValue = group.items[0].stout_purity || 0;
      this.keyForCategory = 'Tunch';
    }

    this.popupForm.patchValue({ value: initialValue });
    this.isPopupOpen = true;
  }

  submitPopup() {
    const val = Number(this.popupForm.get('value')?.value);
    if (isNaN(val)) return;

    let fieldToUpdate = '';
    if (this.selectedGroup.items[0].stout_category_unit === 'By MRP') {
      fieldToUpdate = 'stout_mrp_percent';
    } else if (this.selectedGroup.items[0].stout_category_unit === 'By Gram') {
      fieldToUpdate = 'stout_per_gram_labour';
    } else if (this.selectedGroup.items[0].stout_category_unit === 'By Silver Rate') {
      fieldToUpdate = 'stout_purity';
    }

    this.stockOutService.bulkUpdateItems(this.selectedGroup.items, fieldToUpdate, val).subscribe({
      next: () => {
        this.notificationService.showSuccess('Bulk update applied successfully', 'Success');
        this.closePopup();
        this.getInvoiceItemsDetails();
      },
      error: (err) => {
        console.error(err);
        this.notificationService.showError('Failed to update bulk values', 'Error');
      }
    });
  }

  closePopup() {
    this.isPopupOpen = false;
    this.selectedGroup = null;
  }

  firmTypes: { id: number; name: string }[] = [];
  selectedFirmType: string = '';

  brandSeller: string[] = ['brand 1', 'brand 2', 'brand 3'];
  selectedBrandseller: string = 'brand 1';

  unitTypes: string[] = ['GM', 'KG', 'MG'];
  selectedUnit: string = '';
  selectedLessWtUnit: string = '';
  selectedPktWtUnit: string = '';
  selectedNetWtUnit: string = '';

  selectedMakingChargesUnit: string = '';
  selectedLabChargesUnit: string = '';
  selectedHMChargesUnit: string = '';
  selectedOtherChargesUnit: string = '';
  getSalesAccounts() {
    this.accountService.getAccounts().subscribe({
      next: (res: any) => {
        // Filter for Income/Sales accounts
        this.salesAccounts = res.data.filter((acc: any) => acc.acc_pri_grp === 'Income');
        console.log('Sales Accounts:', this.salesAccounts);

        // Default select 'Sales' account
        this.setDefaultSalesAccount();
      },
      error: (err) => {
        console.error('Error fetching sales accounts:', err);
      }
    });
  }

  ngOnDestroy(): void {
    this.stopAutoWeight();
  }

  loadWeighingScaleSettings(): void {
    this.weightScaleService.getSettings().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.weighingScaleSetting = res.data;
          this.weighingScaleEnabled = !!res.data.enabled;
          
          if (this.weighingScaleEnabled) {
            if (res.data.com_port === 'BROWSER_DIRECT') {
              this.weightScaleService.autoConnectDirectBrowserSerial(
                parseInt(res.data.data_rate) || 9600,
                parseInt(res.data.calibration) || 1
              ).then(success => {
                if (success) {
                  console.log('Connected to browser serial port automatically.');
                }
              });
            } else {
              const ownerId = res.data.owner_id || 1;
              this.weightScaleService.initializeLocalAgent(ownerId).subscribe();
            }
          }
        }
      }
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.weighingScaleEnabled && event.ctrlKey && event.key === 'F2') {
      event.preventDefault();
      this.fetchWeightFromScale();
    }
  }

  fetchWeightFromScale() {
    this.weightScaleService.getWeightFromAgent().subscribe(res => {
      if (res && res.success && res.weight !== undefined) {
        this.sellProductForm.patchValue({
          stout_net_weight: res.weight
        });
        
        if (this.showLotWise) {
          this.onLotNetWtChange({ target: { value: res.weight } });
        }

        this.notificationService.showSuccess(`Fetched weight: ${res.weight}g`, 'Success');
      } else {
        this.notificationService.showError('Could not fetch weight from local agent', 'Error');
      }
    });
  }

  startAutoWeight() {
    if (!this.weighingScaleEnabled) return;
    this.stopAutoWeight();
    this.autoWeightInterval = setInterval(() => {
      this.weightScaleService.getWeightFromAgent().subscribe(res => {
        if (res && res.success && res.weight !== undefined) {
          this.sellProductForm.patchValue({
            stout_net_weight: res.weight
          });
          
          if (this.showLotWise) {
            this.onLotNetWtChange({ target: { value: res.weight } });
          }
        }
      });
    }, 1000);
  }

  stopAutoWeight() {
    if (this.autoWeightInterval) {
      clearInterval(this.autoWeightInterval);
      this.autoWeightInterval = null;
    }
  }
}
